export default __webpack_public_path__ + "static/media/social.20f68972.png";